import React from 'react';

const SolicitacaoPagamentoContext = React.createContext();

export default SolicitacaoPagamentoContext;
